import { GridColumns } from '@mui/x-data-grid-pro'
import {
  CustomQualityControlDto,
  CustomQualityControlType,
} from '@services/dtos'
import { HotLabEquipmentTypeLabels } from '@utils/constants'
import { useEffect, useMemo } from 'react'
import BaseConfigTable from './BaseConfigTable'
import { useAppDispatch } from '@hooks/reduxHooks'
import { AppDispatch } from '@state/store'
import {
  getCustomQualityControls,
  removeCustomQualityControl,
  setCustomQualityControlFilters,
  updateCustomQualityControl,
} from '@state/reducers/customQualityControlReducer'
import { CustomQualityControlTypeLabels } from '@utils/constants'
import CustomQualityControlForm from '../forms/CustomQualityControlForm'

export default function CustomQualityControlsTable() {
  const dispatch = useAppDispatch()
  useEffect(() => {
    return () => {
      dispatch(setCustomQualityControlFilters({ includeInactive: false }))
    }
  }, [])

  const columns: GridColumns<CustomQualityControlDto> = useMemo(
    () => [
      { field: 'code', headerName: 'Code', width: 100 },
      { field: 'label', headerName: 'Libellé', width: 150 },
      {
        field: 'type',
        headerName: 'Type',
        width: 160,
        valueGetter: (params) =>
          CustomQualityControlTypeLabels[params.row.type],
      },
      {
        field: 'expectedResult',
        headerName: 'Valeur attendue',
        valueGetter: (params) => {
          switch (params.row.type) {
            case CustomQualityControlType.LIST:
              return params.row.expectedOption?.label || ''
            case CustomQualityControlType.BOOLEAN:
              return params.row.expected ? 'Oui' : 'Non'
            case CustomQualityControlType.TEXT:
              return params.row.expectedValue || ''
            case CustomQualityControlType.NUMERIC: {
              const { minimum, maximum } = params.row
              if (minimum != null && maximum != null) {
                return `${minimum} – ${maximum}`
              }
              if (minimum != null) {
                return `≥ ${minimum}`
              }
              if (maximum != null) {
                return `≤ ${maximum}`
              }
              return ''
            }
            default:
              return ''
          }
        },
        width: 150,
      },
      { field: 'unit', headerName: 'Unité', width: 100 },
      {
        field: 'equipmentTypes',
        headerName: 'Matériel de laboratoire',
        width: 220,
        valueGetter: (params) =>
          params.row.equipmentTypes?.length
            ? params.row.equipmentTypes.map((t) => HotLabEquipmentTypeLabels[t]).join(', ')
            : '—',
      },
    ],
    [],
  )

  return (
    <BaseConfigTable<CustomQualityControlDto>
      columns={columns}
      selectRows={(state) => state.customQualityControl.items}
      fetchThunk={() => async (dispatch: AppDispatch) => {
        dispatch(setCustomQualityControlFilters({ includeInactive: true }))
        return dispatch(getCustomQualityControls())
      }}
      deleteThunk={removeCustomQualityControl}
      toggleThunk={(id, isActive) =>
        updateCustomQualityControl({ id, dto: { isActive } })
      }
      updatePageThunk={(page) => async (dispatch: AppDispatch) => {
        dispatch(setCustomQualityControlFilters({ page }))
        dispatch(getCustomQualityControls())
      }}
      FormComponent={({ editingItem, onClose }) => (
        <CustomQualityControlForm
          editingCustomQualityControl={editingItem}
          onClose={onClose}
        />
      )}
      resourceLabel="contrôle qualité personnalisé"
      resourcePrefix="le "
    />
  )
}
